import { blue500, red500, green500 } from 'styles/colors';

export const lineStyles = {
  accept: { color: blue500, opacity: 0.65 },
  reject: { color: red500, weight: 5 },
  replace: { color: green500, weight: 3 },
};
